import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import moment from 'moment';
import { PermissionsService } from "src/app/services/permissions/permissions.service";
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { RequestsPulseService } from 'src/app/services/requests/requests-pulse.service';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import {BsModalRef} from "ngx-bootstrap/modal";
import { ConstantsService } from 'src/app/services/constants/constants.service';
@Component({
  selector: 'app-insights-filter-modal',
  templateUrl: './insights-filter-modal.component.pug',
  styleUrls: ['./insights-filter-modal.component.scss'],
  standalone: false
})
export class InsightsFilterModalComponent implements OnInit {

  @Output() applyFilter = new EventEmitter();
  @Output() setLastSelected = new EventEmitter();
  @Output() setAllowedItems = new EventEmitter();
  @Output() refreshData = new EventEmitter();
  filterType = '';
  title = '';
  subHeading = '';
  sortOptions: any = [];
  searchOptions: any = [];
  searchLabels: any = [];
  data:Array<any> = [];
  paginationCriteria = {
    total: 0,
    rowsPerView: 20,
    currentPage: 1,
  }
  searchOption: any = [];
  sortString = '';
  selectAll = false;
  filterOutput = '';
  selectedItems: any = [];
  lastSelected = '';
  allowedItems = new Set();
  selectedDepartmentIds: any;
  selectedSurveyIds: any;
  loaded = false;
  start = moment();
  end = moment();
  unspecifiedWarningCheck = false;
  // Feature flag: When enabled, "Select all" only selects items on the current page
  // When disabled, "Select all" selects all items across all pages
  ENT_10363_PULSE_RELAUNCH = false;

  constructor(
    private permissions: PermissionsService,
    public OrganisationService: OrganisationService,
    public QuestionnaireService: QuestionnaireService,
    public RequestsPulseService: RequestsPulseService,
    public bsModalRef: BsModalRef,
    private ConstantsService: ConstantsService,
  ) { }

  ngOnInit(): void {
    this.ENT_10363_PULSE_RELAUNCH = this.permissions.isFeatureActivated('ent-10363-pulse-relaunch');
    this.searchLabels = this.searchOptions.map(each => each.label);
    this.setModalValues();
  }

  setModalValues() {
    if (this.filterType === 'request') {
      this.title = $localize`Request`;
      this.subHeading = $localize`Filter insights by request.`;
    } else if (this.filterType === 'department') {
      this.title = $localize`Department`;
      this.subHeading = $localize`Filter insights by department.`;
    } else if (this.filterType === 'survey') {
      this.title = $localize`Survey`;
      this.subHeading = $localize`Filter insights by survey.`;
    }
    this.fetchFilterType();
  }

  onSortChange(event){
    this.sortString = event['sortString'];
    this.loaded = false;
    this.fetchFilterType();
  }

  onSearchEvent(event) {
    if (event.search) {
      if (event['type'] === 'Created by') {
        if (this.filterType === 'request') {
          event['type'] = 'created_by';
        } else {
          event['type'] = 'name';
        }
      } else if (event['type'] ==='Survey title') {
        event['type'] = 'title';
      }
      this.searchOption[0] = {key: event['type'].toLowerCase(), value: event['search']};
      this.loaded = false;
      this.fetchFilterType();
    }
  }

  fetchFilterType() {
    if (this.filterType === 'department') {
      this.fetchDepartments();
    } else if (this.filterType === 'request') {
      this.fetchRequests();
    } else if (this.filterType === 'survey') {
      this.fetchSurveys();
    }
  }

  fetchRequests() {
    this.RequestsPulseService.getRequestsDuplicateParams(
      this.searchOption,
      this.paginationCriteria.rowsPerView,
      this.paginationCriteria.currentPage,
      this.sortString,
      this.filterOutput,
      true,
      'insights_available'
    ).subscribe(
      (res) => {
        this.data = res.data.pulses;
        this.paginationCriteria.total = res.data.total;
        this.setSelected();
        this.setDisabled();
        this.loaded = true;
      });
  }

  deprecatedFetchRequests() {
    this.RequestsPulseService.getRequestsDuplicateParams(
      this.searchOption,
      this.paginationCriteria.rowsPerView,
      this.paginationCriteria.currentPage,
      this.sortString,
      this.filterOutput,
      true
    ).subscribe(
      (res) => {
        this.data = res.data.pulses;
        this.paginationCriteria.total = res.data.total;
        this.setSelected();
        this.setDisabled();
        this.loaded = true;
      });
  }

  fetchDepartments() {
    this.OrganisationService.getDepartmentsDuplicateParams(
      this.searchOption,
      this.paginationCriteria.rowsPerView,
      this.paginationCriteria.currentPage,
      this.sortString,
      this.filterOutput,
      'ipd_filter'
    ).subscribe(
      res => {
        this.data = res.data.departments;
        this.paginationCriteria.total = res.data.total;
        this.setSelected();
        this.setDisabled();
        this.loaded = true;
      });
  }

  fetchSurveys() {
    this.QuestionnaireService.getQuestionnairesDuplicateParams(
      this.searchOption,
      this.paginationCriteria.rowsPerView,
      this.paginationCriteria.currentPage,
      this.sortString,
      undefined,
      2,
      'insights_available'
    ).subscribe(
      (res) => {
        this.data = res.data.questionnaires;
        this.paginationCriteria.total = res.data.total;
        this.setSelected();
        this.setDisabled();
        this.loaded = true;
      }, error => {
        console.log(error);
      });
  }

  deprecatedFetchSurveys() {
    this.QuestionnaireService.getQuestionnairesDuplicateParams(
      this.searchOption,
      this.paginationCriteria.rowsPerView,
      this.paginationCriteria.currentPage,
      this.sortString,
      undefined,
      2
    ).subscribe(
      (res) => {
        this.data = res.data.questionnaires;
        this.paginationCriteria.total = res.data.total;
        this.setSelected();
        this.setDisabled();
        this.loaded = true;
      }, error => {
        console.log(error);
      });
  }

  setSelected() {
    if (this.allowedItems.size) {
      if (this.selectedItems.length) {
        if (this.filterType === 'survey') {
          this.selectedItems = this.selectedItems.filter(s => {
            return this.allowedItems.has(parseInt(s.questionnaire.id));
          })
        } else {
          this.selectedItems = this.selectedItems.filter(s => {
            return this.allowedItems.has(parseInt(s.id));
          })
        }
      }
    }
    if (this.filterType === 'survey') {
      this.data.forEach(d => {
        if (this.selectedItems.some(i => i.questionnaire.id === d.questionnaire.id)) {
          d.selected = true;
        }
      });
    } else {
      this.data.forEach(d => {
        if (this.selectedItems.some(i => i.id === d.id)) {
          d.selected = true;
          if(this.filterType === "department"){
            if(d.department === ConstantsService.UNSPECIFIED && d.category_name === ConstantsService.UNSPECIFIED){
              this.unspecifiedWarningCheck = true
            }
          }
        }
      });
    }
  }

  setDisabled() {
    if (this.allowedItems.size) {
      if (this.filterType === 'survey') {
        this.data.forEach(i => {
          if (i.questionnaire.id !== null && !this.allowedItems.has(parseInt(i.questionnaire.id))) {
            i.disable = true;
          }
        });
      } else {
        if (this.filterType === 'department' && this.selectedSurveyIds.length > 0) {
          this.data.forEach(i => {
            if (i.id !== null && !this.allowedItems.has(parseInt(i.id))) {
              i.disable = true;
            }
          });
        }
        else if (this.filterType !== 'department') {
          this.data.forEach(i => {
            if (i.id !== null && !this.allowedItems.has(parseInt(i.id))) {
              i.disable = true;
            }
          });
        }
      }
    }
  }

  onPageChange(pageNumber) {
    this.loaded = false;
    this.paginationCriteria.currentPage = pageNumber;
    this.setModalValues();
  }

  onPageSizeChange(rowsPerView) {
    this.loaded = false;
    this.paginationCriteria.rowsPerView = rowsPerView;
    this.paginationCriteria.currentPage = 1;
    this.setModalValues();
  }

  fetchAll() {
    if (!this.selectedItems.length) {
      // Feature flag: ent-10363-pulse-relaunch
      // When enabled: "Select all" only selects items visible on the current page (based on pagination)
      // When disabled: "Select all" selects all items across all pages (legacy behavior)
      if (this.ENT_10363_PULSE_RELAUNCH) {
        this.selectAllWithPagination();
      } else {
        this.selectAllLegacy();
      }
    } else {
      // Deselect all: Clear selectedItems and update UI state
      this.selectedItems = [];
      if(this.filterType === "department") this.unspecifiedWarningCheck = false;
      this.data.forEach(d => {
        d.selected = false;
      });
    }
  }

  /**
   * NEW BEHAVIOR (Feature flag ON): Select all items on the current page only
   * Fetches all items from API but only selects those visible on the current page
   * based on pagination criteria (rowsPerView and currentPage)
   */
  selectAllWithPagination() {
    // Step 1: Collect IDs of items currently visible on the page (this.data contains current page items)
    const currentPageIds = new Set();
    if (this.filterType === 'survey') {
      this.data.forEach(d => {
        if (d.questionnaire && d.questionnaire.id) {
          currentPageIds.add(d.questionnaire.id.toString());
        }
      });
    } else {
      this.data.forEach(d => {
        if (d.id) {
          currentPageIds.add(d.id.toString());
        }
      });
    }

    // Step 2: Fetch all items from API (rowsPerView: 0 means fetch all)
    // Step 3: Filter to only select items that match current page IDs
    if (this.filterType === 'request') {
      this.loaded = false;
      this.RequestsPulseService.getRequestsDuplicateParams(
        this.searchOption,
        0, // rowsPerView: 0 = fetch all items
        1,
        this.sortString,
        this.filterOutput,
        true
      ).subscribe(
        (res) => {
          // Filter all items to only include those on the current page
          const allItems = res.data.pulses;
          const itemsToSelect = allItems.filter(item => currentPageIds.has(item.id.toString()));
          // Add to selectedItems, avoiding duplicates
          itemsToSelect.forEach(item => {
            if (!this.selectedItems.some(i => i.id === item.id)) {
              this.selectedItems.push(item);
            }
          });
          this.setSelected();
          this.loaded = true;
      });
    } else if (this.filterType === 'department') {
      this.loaded = false;
      this.OrganisationService.getDepartmentsDuplicateParams(
        this.searchOption,
        0, // rowsPerView: 0 = fetch all items
        1,
        this.sortString,
        this.filterOutput,
        'ipd_filter'
      ).subscribe(
        res => {
          // Filter all items to only include those on the current page
          const allItems = res.data.departments;
          const itemsToSelect = allItems.filter(item => currentPageIds.has(item.id.toString()));
          // Add to selectedItems, avoiding duplicates
          itemsToSelect.forEach(item => {
            if (!this.selectedItems.some(i => i.id === item.id)) {
              this.selectedItems.push(item);
            }
          });
          this.setSelected();
          this.loaded = true;
        });
    } else if (this.filterType === 'survey') {
      this.loaded = false;
      this.QuestionnaireService.getQuestionnairesDuplicateParams(
        this.searchOption,
        0, // rowsPerView: 0 = fetch all items
        1,
        this.sortString,
        undefined,
        2
      ).subscribe(
        (res) => {
          // Filter all items to only include those on the current page
          const allItems = res.data.questionnaires;
          const itemsToSelect = allItems.filter(item => 
            item.questionnaire && item.questionnaire.id && 
            currentPageIds.has(item.questionnaire.id.toString())
          );
          // Add to selectedItems, avoiding duplicates
          itemsToSelect.forEach(item => {
            if (!this.selectedItems.some(i => i.questionnaire.id === item.questionnaire.id)) {
              this.selectedItems.push(item);
            }
          });
          this.setSelected();
          this.loaded = true;
        }, error => {
          console.log(error);
        });
    }
  }

  /**
   * LEGACY BEHAVIOR (Feature flag OFF): Select all items across all pages
   * Fetches all items from API and selects all of them without pagination filtering
   */
  selectAllLegacy() {
    if (this.filterType === 'request') {
      this.loaded = false;
      this.RequestsPulseService.getRequestsDuplicateParams(
        this.searchOption,
        0, // rowsPerView: 0 = fetch all items
        1,
        this.sortString,
        this.filterOutput,
        true
      ).subscribe(
        (res) => {
          // Select all items without pagination filtering
          this.selectedItems = res.data.pulses;
          this.setSelected();
          this.loaded = true;
      });
    } else if (this.filterType === 'department') {
      this.loaded = false;
      this.OrganisationService.getDepartmentsDuplicateParams(
        this.searchOption,
        0, // rowsPerView: 0 = fetch all items
        1,
        this.sortString,
        this.filterOutput,
        'ipd_filter'
      ).subscribe(
        res => {
          // Select all items without pagination filtering
          this.selectedItems = res.data.departments;
          this.setSelected();
          this.loaded = true;
        });
    } else if (this.filterType === 'survey') {
      this.loaded = false;
      this.QuestionnaireService.getQuestionnairesDuplicateParams(
        this.searchOption,
        0, // rowsPerView: 0 = fetch all items
        1,
        this.sortString,
        undefined,
        2
      ).subscribe(
        (res) => {
          // Select all items without pagination filtering
          this.selectedItems = res.data.questionnaires;
          this.setSelected();
          this.loaded = true;
        }, error => {
          console.log(error);
        });
    }
  }

  cancel() {
    this.bsModalRef.hide();
  }

  next() {
    if (this.selectedItems.length === 1) {
      if (this.filterType === 'request') {
        this.lastSelected = this.selectedItems[0].name;
      } else if (this.filterType === 'department') {
        this.lastSelected = this.selectedItems[0].department;
      } else if (this.filterType === 'survey') {
        this.lastSelected = this.selectedItems[0].name;
      }
    } else if (this.selectedItems.length > 1) {
      this.lastSelected = this.selectedItems.length + ' ' + $localize`selected`;
    } else {
      this.lastSelected = $localize`All`;
      if (!this.selectedDepartmentIds) {
        this.selectedSurveyIds = [];
      }
      if (!this.selectedSurveyIds) {
        this.selectedDepartmentIds = [];
      }
    }
    this.getAllowedData();
  }

  getAllowedData() {
    let ids = [];
    if (this.filterType !== 'survey') {
      ids = this.selectedItems.map(i => i.id);
    } else {
      ids = this.selectedItems.map(i => i.questionnaire.id);
    }
    this.loaded = false;
    if (this.filterType === 'department') {
      this.RequestsPulseService.getCheckPulse(
        this.selectedSurveyIds,
        ids,
        ''
      ).subscribe(
        (res) => {
          this.applyFilters(res.data)
          this.loaded = true;
        });
    } else if (this.filterType === 'request') {
      this.RequestsPulseService.getCheckPulse(
        '',
        '',
        ids,
        this.start,
        this.end
      ).subscribe(
        (res) => {
          this.applyFilters(res.data);
          this.loaded = true;
        }
      )
    } else if (this.filterType === 'survey') {
      this.RequestsPulseService.getCheckPulse(
        ids,
        this.selectedDepartmentIds,
        '',
        this.start,
        this.end
      ).subscribe(
        (res) => {
          this.applyFilters(res.data);
          this.loaded = true;
        }
      )
    }
  }

  applyFilters(data) {
    this.applyFilter.emit(this.selectedItems);
    this.setAllowedItems.emit(data)
    this.setLastSelected.emit(this.lastSelected);
    this.bsModalRef.hide();
  }

  selectedItem(item) {
    if (!item.disable) {
      if (item.selected) {
        item.selected = false;
        this.selectedItems = this.selectedItems.filter(i => i.id !== item.id);
        if(item.department === ConstantsService.UNSPECIFIED && item.category_name === ConstantsService.UNSPECIFIED){
          this.unspecifiedWarningCheck = false
        }
      }
      else {
        item.selected = true;
        if(item.department === ConstantsService.UNSPECIFIED && item.category_name === ConstantsService.UNSPECIFIED){
          this.unspecifiedWarningCheck = true;
        }
        this.selectedItems.push(item);
      }
    }
  }
}
